<div class="card p-3 mt-2">
  <nz-skeleton [nzLoading]="loading" [nzActive]="true" class="d-flex flex-column">
    <div class="d-flex flex-column gap-2">
        <div class="title">Expedition Settings</div>
        <span class="text-secondary text-wrap">Take control of your courier preferences and optimize your deliveries.</span>
    </div>
        <div class="mt-3 col-12">
          <div class="d-flex flex-column" style="overflow-x: auto">
              <nz-table
                  #basicTable
                  [nzData]="listOfData"
                  [nzShowPagination]="false"
                  class="table table-hover table-responsive"
                  >
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (data of basicTable.data; track data) {
                <tr>
                  <td>
                      <div class="d-flex align-items-center gap-2">
                          <img [src]="data.shipping_logo" alt="logo" class="me-2" style="width: 60px;">
                          <span class="text-capitalize">{{ data.shipping_name }}</span>
                      </div>
                  <td>
                      <div class="text-capitalize rounded-pill px-4 py-1 d-flex align-items-center justify-content-center" [ngClass]="getClassStatus(data.is_active)">
                          {{ getClassStatus(data.is_active) }}
                      </div>
                  </td>
                  <td><nz-switch [(ngModel)]="data.is_active" (ngModelChange)="changeStatus(data)"></nz-switch></td>
                </tr>
              }
            </tbody>
          </nz-table>
          </div>
        </div>
  </nz-skeleton>
</div>
